export const isNotNullOrUndefined = <T>(value: T | null | undefined): value is T =>
  value !== null && value !== undefined;

export const isNullOrUndefined = <T>(value: T | null | undefined): value is null | undefined =>
  !isNotNullOrUndefined(value);

export function assertPresent<T>(value: T | undefined | null, name: string): T {
  if (!value) {
    throw new Error(`Expected value to be defined: '${name}'`);
  }
  return value;
}

export type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

export function entries<T extends {}>(obj: T): Entries<T> {
  return Object.entries(obj) as Entries<T>;
}
